@if (storageType === StorageType.Minio) {
  <mbs-card-group>
    <div
      #innerAccordion="ngbAccordion"
      class="mbs-accordion mbs-accordion-transparent credential-form-accordion"
      ngbAccordion>
      <div
        #item="ngbAccordionItem"
        ngbAccordionItem>
        <div
          class="accordion-button"
          ngbAccordionHeader>
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div
              class="d-flex align-items-center cursor-pointer"
              ngbAccordionToggle>
              <span
                class="ico"
                [ngClass]="{ 'ico-arrRight': item.collapsed, 'ico-arrDown': !item.collapsed }"></span>
              <h4 class="my-0 ml-2">{{ 'storages:addStorageAccountWizard.inputCredentialsStep.additionalOptions' | i18next }}</h4>
            </div>
            <a
              target="_blank"
              [helpLink]="helpLink"
              >{{ 'shared:buttons.learnMore' | i18next }}</a
            >
          </div>
        </div>
        <div ngbAccordionCollapse>
          <div
            class="mt-3"
            ngbAccordionBody>
            <ng-template>
              <ng-container *ngTemplateOutlet="additionalTmp"></ng-container>
              <ng-container *ngTemplateOutlet="ignoreCertificateTmp"></ng-container>
              <ng-container *ngTemplateOutlet="versioningTmp"></ng-container>
              <ng-container *ngTemplateOutlet="accessStyleTmp"></ng-container>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </mbs-card-group>
} @else {
  <mbs-card class="card-form">
    <mbs-card-header>
      <ng-template>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <h4 class="my-0 ml-2">{{ 'storages:addStorageAccountWizard.advancedSettingsStep.title' | i18next }}</h4>
          </div>

          <a
            target="_blank"
            [helpLink]="helpLink"
            >{{ 'shared:buttons.learnMore' | i18next }}</a
          >
        </div>
      </ng-template>
    </mbs-card-header>

    <mbs-card-group>
      <ng-container *ngTemplateOutlet="ignoreCertificateTmp"></ng-container>
      <ng-container *ngTemplateOutlet="versioningTmp"></ng-container>
      <ng-container *ngTemplateOutlet="signatureTmp"></ng-container>
      <ng-container *ngTemplateOutlet="accessStyleTmp"></ng-container>
    </mbs-card-group>
  </mbs-card>
}

<ng-template #ignoreCertificateTmp>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.ignoreCertificate"
      [formControl]="ignoreCertificate"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.ignoreCertificate' | i18next"></mbs-checkbox>
  </mbs-form-group>
</ng-template>

<ng-template #versioningTmp>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.isVersioningEnabled"
      [formControl]="isVersioningEnabled"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.versioning' | i18next"></mbs-checkbox>
  </mbs-form-group>

  @if ('AllowKeepCredsOnEndpoint' | can: 'read') {
    <mbs-form-group>
      <mbs-checkbox
        [attr.data-e2e]="e2eLocators.keepCredentialsOnEndpoint"
        [formControl]="keepCredentialsOnEndpoint"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.keepCredentials' | i18next"></mbs-checkbox>
    </mbs-form-group>
  }

  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.isSyntheticBackupAllowed"
      [formControl]="isSyntheticBackupAllowed"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.allowSyntheticFullBackup' | i18next"></mbs-checkbox>
  </mbs-form-group>

  @if (isNativeMultipartControlShown) {
    <mbs-form-group>
      <mbs-checkbox
        [attr.data-e2e]="e2eLocators.useNativeMultipartUpload"
        [formControl]="useNativeMultipartUpload"
        [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.useNativeUpload' | i18next"></mbs-checkbox>
    </mbs-form-group>
  }
</ng-template>

<ng-template #signatureTmp>
  <mbs-form-group>
    <mbs-input-label
      [boldLabel]="true"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.signatureVersion' | i18next"></mbs-input-label>
    <div class="row">
      <div class="col-auto">
        <mbs-radio
          [attr.data-e2e]="e2eLocators.useSignatureVersion4"
          [formControl]="useSignatureVersion4"
          [label]="'4'"
          [name]="'useSignatureVersion4'"
          [value]="true">
        </mbs-radio>
      </div>
      <div class="col-auto">
        <mbs-radio
          [attr.data-e2e]="e2eLocators.useSignatureVersion2"
          [formControl]="useSignatureVersion4"
          [label]="'2'"
          [name]="'useSignatureVersion4'"
          [value]="false">
        </mbs-radio>
      </div>
    </div>
  </mbs-form-group>
</ng-template>

<ng-template #accessStyleTmp>
  <mbs-form-group>
    <mbs-input-label
      [boldLabel]="true"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.accessStyle' | i18next"></mbs-input-label>

    <div class="row mt-2">
      <div class="col-auto">
        <mbs-radio
          [attr.data-e2e]="e2eLocators.useVHostRequestStyleFalse"
          [formControl]="useVHostRequestStyle"
          [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.pathStyle' | i18next"
          [name]="'useVHostRequestStyle'"
          [value]="false">
        </mbs-radio>
      </div>
      <div class="col-auto">
        <mbs-radio
          [attr.data-e2e]="e2eLocators.useVHostRequestStyleTrue"
          [formControl]="useVHostRequestStyle"
          [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.hostStyle' | i18next"
          [name]="'useVHostRequestStyle'"
          [value]="true">
        </mbs-radio>
      </div>
    </div>
  </mbs-form-group>
</ng-template>

<ng-template #additionalTmp>
  <mbs-form-group>
    <mbs-checkbox
      [attr.data-e2e]="e2eLocators.isPrivateStorage"
      [formControl]="isPrivateStorage"
      [label]="'storages:addStorageAccountWizard.inputCredentialsStep.labels.checkCredentials' | i18next"></mbs-checkbox>
  </mbs-form-group>
</ng-template>

<ng-template #changeToHostStyle>
  <div
    [innerHTML]="
      'storages:addStorageAccountWizard.inputCredentialsStep.changeToHostStyleText' | i18next: { storage: storageType | storageDisplayName }
    "></div>
</ng-template>
